import {
  COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN,
  COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS,
  COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE,
  COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function saveDataInExternaldatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}appwrites/create`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE,
            data: { error: err },
          });
          console.log('errr', err);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveDataInExternaldatabaseError() {
  return {
    type: COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN:
      return {
        ...state,
        saveDataInExternaldatabasePending: true,
        saveDataInExternaldatabaseError: null,
      };

    case COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS:
      return {
        ...state,
        saveDataInExternaldatabasePending: false,
        saveDataInExternaldatabaseError: null,
        dbCollectionUuid: action.data.uuid,
      };

    case COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE:
      return {
        ...state,
        saveDataInExternaldatabasePending: false,
        saveDataInExternaldatabaseError: action.data.error,
      };

    case COLLECTIONS_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR:
      return {
        ...state,
        saveDataInExternaldatabaseError: null,
      };

    default:
      return state;
  }
}
